import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { NgApexchartsModule, ChartComponent } from 'ng-apexcharts';
import { ChartOptions } from '../../model/spider-chart/chart-options';
import {
  SpiderChartModel,
  SpiderChartSeries,
} from '../../model/spider-chart/spider-chart-model';

@Component({
  selector: 'app-spider-chart',
  templateUrl: 'spider-chart.component.html',
  styleUrls: ['spider-chart.component.scss'],
  standalone: true,
  imports: [CommonModule, NgApexchartsModule],
})
export class SpiderChartComponent implements OnInit, OnChanges {
  @Input() data: SpiderChartModel;

  @ViewChild('chart') chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  isDataAvailable: boolean = false;

  constructor() {}

  ngOnInit() {
    this.initializeChart();
  }

  ngOnChanges() {
    this.initializeChart();
  }

  private initializeChart() {
    this.isDataAvailable = false;
    this.chartOptions = this.getDefaultChartOptions();

    if (!this.data || !this.data.series || this.data.series.length === 0) {
      this.chartOptions.series = [];
      this.chartOptions.xaxis.categories = [];
      return;
    }

    this.isDataAvailable = true;

    // Chart title
    this.chartOptions.title.text = this.data?.title || 'No data provided';

    for (let i = 0; i < this.data.series.length; i++) {
      const series: SpiderChartSeries = this.data.series[i];
      const seriesData: number[] = series.data.map((item) => item.value);
      this.chartOptions.series.push({
        name: series.name,
        data: seriesData,
      });
    }

    this.chartOptions.xaxis.categories = this.data.series[0].data.map(
      (item) => item.label
    );
  }

  private getDefaultChartOptions(): ChartOptions {
    return {
      title: {
        text: '',
      },

      series: [],
      chart: {
        type: 'radar',
        height: 425,
        toolbar: {
          show: false, // Do not allow user to download the chart
        },
        offsetX: -50,
        offsetY: -50,
      },
      xaxis: {
        categories: [],
        min: 0,
        max: 5,
        tickAmount: 5,
        labels: {
          show: true,
          style: {
            colors: '#0A0A0A',
            fontSize: '1em',
            fontFamily: 'RFEBM',
            fontWeight: 400,
            cssClass: 'apexcharts-xaxis-label',
          },
        },
      },
      yaxis: {
        show: false,
        min: 0,
        max: 5,
        tickAmount: 5,
        labels: {
          show: false,
        },
      },
      options: {
        colors: ['#FE192F', '#47050B'],
        stroke: {
          show: true,
          width: 2,
        },

        legend: {
          show: true,
          position: 'right',
          inverseOrder: true,
          horizontalAlign: 'center',
          floating: true,
          fontSize: '1rem',
          fontFamily: 'RFEBM',
          offsetX: -40,
          formatter: function (seriesName: string) {
            return seriesName.length > 16
              ? seriesName.slice(0, 13) + '...'
              : seriesName;
          },
        },
        tooltip: {
          enabled: true,
          style: {
            fontSize: '1em',
            fontFamily: 'RFEBM',
          },
        },
        fill: {
          opacity: 0,
        },
        markers: {
          size: 8,
          hover: {
            size: 10,
          },
          fillOpacity: 1,
        },
        plotOptions: {
          radar: {
            polygons: {
              strokeColors: '#d8d8d8',
              strokeWidth: '0.05em',
              fill: {
                colors: ['#fff'],
              },
            },
          },
        },
      },
    };
  }
}
